import type { AccountConfirmationSent } from '@chukua/common';
import { api } from '../../shared/shared.api';

/** Sends a code to the person's own email or mobile, to prove it's them before a sensitive change. A test deployment returns the code too. */
export function sendAccountConfirmation(): Promise<AccountConfirmationSent> {
  return api<AccountConfirmationSent>('/account/confirmation/send', { method: 'POST' });
}

/** A correct code confirms the session for 10 minutes, so changes made in that time go straight through. */
export function confirmAccount(code: string): Promise<void> {
  return api<void>('/account/confirmation', { method: 'POST', body: JSON.stringify({ code }) });
}
